/**
 * CiaoWarningModal — Warning when enabling auto-execute mode
 */

import React from 'react';
import { IoWarning, IoShield } from 'react-icons/io5';

interface CiaoWarningModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const CiaoWarningModal: React.FC<CiaoWarningModalProps> = ({ onConfirm, onCancel }) => {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 100001,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.5)',
        backdropFilter: 'blur(4px)',
      }}
      onClick={onCancel}
    >
      <div
        className="ciao-animate-scale-in"
        style={{
          width: '100%',
          maxWidth: 400,
          margin: '0 16px',
          background: 'var(--background-color, #fff)',
          borderRadius: 16,
          overflow: 'hidden',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '16px 20px',
            background: 'rgba(245,158,11,0.08)',
            borderBottom: '1px solid rgba(245,158,11,0.15)',
          }}
        >
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              background: 'rgba(245,158,11,0.15)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <IoWarning size={20} color="#f59e0b" />
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-color, #333)' }}>
              Modo Ejecución Directa
            </div>
            <div style={{ fontSize: 11, color: 'var(--text-color-muted, #888)', marginTop: 1 }}>
              Esta acción tiene implicaciones
            </div>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: '16px 20px' }}>
          <p style={{ fontSize: 13, lineHeight: 1.6, color: 'var(--text-color, #555)', margin: '0 0 12px' }}>
            Al activar este modo, Ciao ejecutará operaciones de escritura (crear, modificar, eliminar)
            <strong> sin pedir confirmación</strong>.
          </p>

          <div
            style={{
              padding: '10px 12px',
              borderRadius: 8,
              background: 'rgba(239,68,68,0.06)',
              border: '1px solid rgba(239,68,68,0.12)',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
              <IoShield size={13} color="#ef4444" />
              <span style={{ fontSize: 11, fontWeight: 600, color: '#ef4444' }}>Riesgos incluyen:</span>
            </div>
            <ul style={{ margin: 0, paddingLeft: 20, fontSize: 12, lineHeight: 1.7, color: 'var(--text-color, #666)' }}>
              <li>Items del menú creados, modificados o eliminados sin revisión</li>
              <li>Pedidos cancelados o movidos inmediatamente</li>
              <li>Permisos de usuario modificados sin confirmación</li>
              <li>Movimientos de caja registrados automáticamente</li>
            </ul>
          </div>

          <p style={{ fontSize: 12, color: 'var(--text-color-muted, #888)', marginTop: 12, marginBottom: 0 }}>
            Puedes desactivar este modo en cualquier momento.
          </p>
        </div>

        {/* Actions */}
        <div
          style={{
            display: 'flex',
            gap: 10,
            padding: '12px 20px 16px',
          }}
        >
          <button
            onClick={onCancel}
            style={{
              flex: 1,
              padding: '10px 16px',
              borderRadius: 8,
              background: 'rgba(0,0,0,0.06)',
              color: 'var(--text-color, #666)',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'background 0.15s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(0,0,0,0.1)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(0,0,0,0.06)'; }}
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1,
              padding: '10px 16px',
              borderRadius: 8,
              background: '#f59e0b',
              color: '#fff',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'background 0.15s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#d97706'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = '#f59e0b'; }}
          >
            Entiendo, activar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CiaoWarningModal;
